import React, { useState} from "react";
import {Modal, Checkbox, Input, Form} from "antd";
import Draggable from "react-draggable";
import {request} from "../../util/request";
import {GLOBAL_CONNECTION_API} from "../../config/api";
import {ObjTest} from "jzfz-web-utils";
import CustomEmpty from "../customEmpty/CustomEmpty";
import Uploader from "../attachment/Uploader";
import './style/attachmentSelectModal.less';


const { Search } = Input;
/**
 * 附件去重
 * @param fileList 附件列表
 */
export const removeRepeat = (fileList: any[]): any[] => {
    let ids = [];
    let files = fileList.map((v: any) => {
        if (!ids.includes(v.attachmentId)) {
            ids.push(v.attachmentId);
            return v;
        }
        return null;
    }).filter((v: any) => v);

    return files;
}


interface AttachmentSelectModalProps {
    visible: boolean;
    attachementList: any[];  // 当前内容的附件列表
    onChecked?: (pkid: string) => void; // 选择附件, pkid:附件id
    onSubmit?: (info: any[]) => void;
    onCancel?: () => void;
    onChange?: (fileList: any[]) => void;  // 附件上传后回调
}



/**
 * 附件选择弹窗
 * @constructor
 */
const AttachmentSelectModal = (props: AttachmentSelectModalProps) => {
    const {
        visible,
        attachementList,
        onSubmit = (pkids: string[]) => {},
        onCancel = () => {},
        onChange = (fileList: any[]) => {},
    } = props;
    const [dataSource, setDataSource] = useState<any[]>([]);  // 库中已有的附件列表
    const [loading, setLoading] = useState<boolean>(false);
    const [checkedPkids, setCheckedPkids] = useState<string[]>([]); // 已选中的附件id集合
    const [form] = Form.useForm();
    const { resetFields } = form;


    /**
     * 搜索附件
     * @param value
     */
    const searchHandle = (value?: string) => {
        if (!value || value.replace(/\s/g, '') === '') {
            setDataSource([]);
            return;
        }
        setLoading(true);
        request('/attachment/query', {keyword: value}, {method: 'get', baseURL: GLOBAL_CONNECTION_API}).then((res: any) => {
            setDataSource(res.data || []);
        }).finally(() => {
            setLoading(false);
        })
    }


    /**
     * 上传附件后回调
     * @param fileList
     */
    const changeHandle = (fileList: any[]) => {
        onChange(fileList);
        let ids = fileList.map((v: any) => v.attachmentId);
        setCheckedPkids(Array.from(new Set([...checkedPkids, ...ids])));
    }


    /**
     * 选择附件
     * @param pkid
     */
    const checkedHandle = (pkid: string, e: any) => {
        const { checked } = e.target;
        if (checked) {
            setCheckedPkids([...checkedPkids, pkid]);
        }else {
            setCheckedPkids(checkedPkids.filter((v: any) => v !== pkid));
        }
    }


    /**
     * 确定
     */
    const submitHandle = () => {
        let current = attachementList.filter((v: any) => checkedPkids.includes(v.attachmentId));
        let storage = dataSource.filter((v: any) => checkedPkids.includes(v.attachmentId));
        let files = [...current, ...storage];
        onSubmit(removeRepeat(files));
    }


    return (
        <Modal
            wrapClassName="attachment-select-modal"
            forceRender={true}
            maskClosable={false}
            mask={false}
            title="选择要插入的附件"
            closable={false}
            width={800}
            visible={visible}
            afterClose={() => {
                resetFields();
                setCheckedPkids([]);
                setDataSource([]);
            }}
            okText="插入"
            okButtonProps={{className: 'button-red'}}
            onOk={submitHandle}
            onCancel={onCancel}
            modalRender={(node: React.ReactNode) => (
                <Draggable handle=".attachment-select-modal .ant-modal-header">{node}</Draggable>
            )}
        >
            <div className="flex">
                <div className="flex1 current-list-wrap">
                    <div className="flexic lh32">
                        <span className="f14 b">当前内容上传的附件</span>
                        <Uploader className="mla" onChange={changeHandle} />
                    </div>
                    <div className="list">
                        {
                            ObjTest.isNotEmptyArray(attachementList) ? (
                                attachementList.map((v: any, i: number) => (
                                    <div className="list-item" key={i}>
                                        <Checkbox
                                            className="checkbox-wrap"
                                            checked={checkedPkids.includes(v.attachmentId)}
                                            onChange={(e) => checkedHandle(v.attachmentId, e)}
                                        >
                                            <span className="title-text">{v.fileName}</span>
                                            <span className="size-text">{v.size}</span>
                                        </Checkbox>
                                    </div>
                                ))
                            ) : (
                                <CustomEmpty text="当前内容暂无附件" />
                            )
                        }
                    </div>
                </div>
                <div className="flex1 all-list-wrap">
                    <div className="flexic">
                        <span className="f14 b">查找库中已有的附件</span>
                        <Form className="mla" name="attachmentSelectForm" form={form}>
                            <Form.Item noStyle name="keyword">
                                <Search placeholder="搜索附件名称" allowClear onSearch={searchHandle} style={{width: 200}} />
                            </Form.Item>
                        </Form>
                    </div>
                    <div className="list">
                        {
                            ObjTest.isNotEmptyArray(dataSource) ? (
                                dataSource.map((v: any, i: number) => (
                                    <div className="list-item" key={i}>
                                        <Checkbox
                                            className="checkbox-wrap"
                                            checked={checkedPkids.includes(v.attachmentId)}
                                            onChange={(e) => checkedHandle(v.attachmentId, e)}
                                        >
                                            <span className="title-text">{v.fileName}</span>
                                            <span className="size-text">{v.size}</span>
                                        </Checkbox>
                                    </div>
                                ))
                            ) : (
                                <CustomEmpty loading={loading} text="" />
                            )
                        }
                    </div>
                </div>
            </div>
        </Modal>
    )
}


export default AttachmentSelectModal;
